// eslint-disable-next-line import/prefer-default-export
import SurfaceWater from '../../images/map-layers/surface-water.png';
import AirQuality from '../../images/map-layers/air-quality.png';
import CommonLand from '../../images/map-layers/common-land.png';
import LandfillSites from '../../images/map-layers/landfill-sites.png';
import NationalParks from '../../images/map-layers/national-parks.png';
import NitrateVulnerableZones from '../../images/map-layers/nitrate-vulnerable-zones.png';
import AreasOfNaturalBeauty from '../../images/map-layers/areas-of-natural-beauty.png';
import RoadNoise from '../../images/map-layers/road-noise.png';
import RailNoise from '../../images/map-layers/rail-noise.png';
import Default from '../../images/map-layers/default.png';
import ConversationArea from '../../images/map-layers/conservation-area.png';
import LocalNatureReserves from '../../images/map-layers/local-nature-reserves.png';
import SoilTexture from '../../images/map-layers/soil-texture.png';
import RadonGas from '../../images/map-layers/radon-gas.png';

export default [
  {
    id: 'default',
    tiles: [],
    label: 'None',
    image: Default,
  },
  {
    id: 'air-quality',
    tiles: [
      'https://geoserver.rcdo.co.uk/geoserver/Forecasting/wms?SERVICE=WMS&request=GetMap&width=256&height=256&layers=AQ_Fcast_day1&format=image/png&bbox={bbox-epsg-3857}&crs=EPSG:3857',
    ],
    label: 'Air quality',
    image: AirQuality,
  },
  {
    id: 'areas-of-natural-beauty',
    tiles: [
      'https://environment.data.gov.uk/spatialdata/areas-of-outstanding-natural-beauty-england/wms?request=GetMap&format=image/png&width=256&height=256&layers=Areas_of_Outstanding_Natural_Beauty_England&crs=EPSG:3857&bbox={bbox-epsg-3857}&transparent=true',
    ],
    label: 'AONB',
    image: AreasOfNaturalBeauty,
  },
  {
    id: 'common-land',
    tiles: [
      'https://environment.data.gov.uk/spatialdata/rpa-registered-common-land-layer/wms?request=GetMap&format=image/png&width=256&height=256&layers=rpa_registered_common_land&crs=EPSG:3857&bbox={bbox-epsg-3857}&transparent=true',
    ],
    label: 'Common land',
    image: CommonLand,
  },
  {
    id: 'conservation-areas',
    tiles: [
      'https://environment.data.gov.uk/spatialdata/special-areas-of-conservation-england/wms?request=GetMap&format=image/png&width=256&height=256&layers=Special_Areas_of_Conservation_England&crs=EPSG:3857&bbox={bbox-epsg-3857}&transparent=true',
    ],
    label: 'Conservation areas',
    image: ConversationArea,
  },
  {
    id: 'historic-landfill',
    tiles: [
      'https://environment.data.gov.uk/spatialdata/historic-landfill/wms?request=GetMap&format=image/png&width=256&height=256&layers=Historic_Landfill_Sites&crs=EPSG:3857&bbox={bbox-epsg-3857}&transparent=true',
    ],
    label: 'Historic landfill',
    image: LandfillSites,
  },
  {
    id: 'local-nature-reserves',
    tiles: [
      'https://environment.data.gov.uk/spatialdata/local-nature-reserves-england/wms?request=GetMap&layers=Local_Nature_Reserves_England&width=256&height=256&format=image/png&bbox={bbox-epsg-3857}&crs=EPSG:3857',
    ],
    label: 'LNR',
    image: LocalNatureReserves,
  },
  {
    id: 'national-parks',
    tiles: [
      'https://environment.data.gov.uk/spatialdata/national-parks-england/wms?request=GetMap&format=image/png&width=256&height=256&layers=National_Parks_England&crs=EPSG:3857&bbox={bbox-epsg-3857}&transparent=true',
    ],
    label: 'National parks',
    image: NationalParks,
  },
  {
    id: 'nitrate-vulnerable-zones',
    tiles: [
      'https://environment.data.gov.uk/spatialdata/nitrate-vulnerable-zones-2021-designations/wms?request=GetMap&format=image/png&width=256&height=256&layers=Nitrate_Vulnerable_Zones_2021_Designations&crs=EPSG:3857&bbox={bbox-epsg-3857}&transparent=true',
    ],
    label: 'NVZ',
    image: NitrateVulnerableZones,
  },
  {
    id: 'radon-gas',
    tiles: [
      'https://map.bgs.ac.uk/arcgis/services/GeoIndex_Onshore/radon/MapServer/WmsServer?service=WMS&version=1.3.0&request=GetMap&layers=Radon.1km&styles=default&format=image/png&width=256&height=256&bbox={bbox-epsg-3857}&crs=EPSG:3857',
    ],
    label: 'Radon gas',
    image: RadonGas,
  },
  {
    id: 'rail-noise',
    tiles: [
      'https://environment.data.gov.uk/spatialdata/rail-noise-laeq-16h-england-round-3/wms?request=GetMap&format=image/png&width=256&height=256&layers=Rail_Noise_LAeq16h_England_Round_3&crs=EPSG:3857&bbox={bbox-epsg-3857}&transparent=true',
    ],
    label: 'Rail noise',
    image: RailNoise,
  },
  {
    id: 'road-noise',
    tiles: [
      'https://environment.data.gov.uk/spatialdata/road-noise-lden-england-round-3/wms?request=GetMap&format=image/png&width=256&height=256&layers=Road_Noise_Lden_England_Round_3&crs=EPSG:3857&bbox={bbox-epsg-3857}&transparent=true',
    ],
    label: 'Road noise',
    image: RoadNoise,
  },
  {
    id: 'soil-texture',
    tiles: [
      'https://map.bgs.ac.uk/arcgis/services/UKSO/UKSO_BGS/MapServer/WMSServer?service=WMS&version=1.3.0&request=GetMap&bbox={bbox-epsg-3857}&transparent=true&layers=Parent.Material.Soil.texture.simple&format=image/png&width=256&height=256&crs=EPSG:3857&styles=default',
    ],
    label: 'Soil texture',
    image: SoilTexture,
  },
  {
    id: 'surface-water',
    tiles: [
      'https://environment.data.gov.uk/spatialdata/risk-of-flooding-from-surface-water-depth-0-1-percent-annual-chance/wms?request=GetMap&format=image/png&width=256&height=256&layers=Risk_of_Flooding_from_Surface_Water_Depth_0_1_percent_annual_chance&crs=EPSG:3857&bbox={bbox-epsg-3857}&transparent=true',
    ],
    label: 'Surface water',
    image: SurfaceWater,
  },
];
